import { createContext } from "react";

const CompanyContext = createContext('company')

export default CompanyContext